import React from 'react';

/**
 * Render the default FLARE modular mark for the sidebar logo slot.
 *
 * @param {object} props - Logo presentation props.
 * @returns {React.ReactElement} FLARE logo mark.
 */
const LOGO_DEFAULTS = Object.freeze({ label: 'FLARE', compact: false });

export default function FlareLogoMark(props) {
  const { themeTokens, label, compact = false } = { ...LOGO_DEFAULTS, ...props };
  const tokens = Object.assign({}, themeTokens);
  const accent = [tokens.bubbleUserBg, '#2474ff'].find(Boolean);
  const textColor = [tokens.textPrimary, '#0f172a'].find(Boolean);
  const muted = [tokens.textSecondary, '#64748b'].find(Boolean);
  const gradientSuffix = [String(accent).replace(/[^a-zA-Z0-9_-]/g, ''), 'default'].find(Boolean);
  const gradientId = `flare-logo-one-stroke-gradient-${gradientSuffix}`;
  const oneStrokePath = 'M16 4 26.4 10 26.4 22 16 28 5.6 22 5.6 10 16 4 5.6 10V12.4H20.8H5.6V16.3H17.6H5.6V22';

  const mark = (
    <svg
      aria-hidden="true"
      fill="none"
      height="28"
      viewBox="0 0 32 32"
      width="28"
    >
      <defs>
        <linearGradient id={gradientId} x1="6" x2="26" y1="5" y2="27" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#0f4fd8" />
          <stop offset="0.58" stopColor={accent} />
          <stop offset="1" stopColor="#1f3f8f" />
        </linearGradient>
      </defs>
      <path
        d="M16 4 26.4 10v12L16 28 5.6 22V10Z"
        fill={`url(#${gradientId})`}
        opacity="0.07"
      />
      <path
        d={oneStrokePath}
        stroke={accent}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.6"
        opacity="0.08"
      />
      <path
        d={oneStrokePath}
        stroke={`url(#${gradientId})`}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.95"
      />
    </svg>
  );

  if (compact) {
    return (
      <div style={{ alignItems: 'center', display: 'inline-flex', justifyContent: 'center' }}>
        {mark}
      </div>
    );
  }

  return (
    <div style={{ alignItems: 'center', display: 'inline-flex', gap: 10 }}>
      {mark}
      <span style={{ color: textColor, fontSize: 16, fontWeight: 700, letterSpacing: '0.02em' }}>
        {label}
      </span>
      <span style={{ color: muted, fontSize: 11, fontWeight: 600, letterSpacing: '0.08em' }}>
        WORKSPACE
      </span>
    </div>
  );
}
